import { useState, useEffect, useContext } from 'react'
import { CustomerContext } from '../../contexts/CustomerContext';
import reformatSchedules from './reformat-schedules';

const useReformattedSchedules = (schedules, minValue, schoolId = undefined, apptTimeframe) => {
  const [reformatted, setReformatted] = useState({})
  const { customer } = useContext(CustomerContext)
  const currentSchoolId = (customer && customer.currentSchool.id) || schoolId;

  useEffect(() => {
    if (!apptTimeframe) return;
    if (schedules.some((schedule) => !schedule.availableTimeslots)) return

    setReformatted(reformatSchedules(schedules, minValue, currentSchoolId, apptTimeframe))
  }, [schedules])

  return reformatted
}

export default useReformattedSchedules
